/* Zydonia: einheitliche Variantenauswahl auf Produktseiten (Raumduft, Parfums, Kerzen, Öle).
   1. Variantenfelder immer mit Farbpunkt vorne und Name dahinter:
      - Craft-Auswahl (variant-selects): eigene Knöpfe, die die Original-Felder bedienen
      - Auswahllisten der Buyboxen (select[data-zyd-scent], select[data-zyd-gift]): eigenes Aufklappfeld, das die Liste bedient
   2. Info-Block [data-zyx-vi] über der Auswahl: Name, Unterzeile, Preis, Satz, drei Hauptnoten der gewählten Variante.
   Die bestehende Kauflogik bleibt unverändert: Wir setzen nur die Original-Felder und lösen deren change-Ereignis aus. */
(function () {
  const VD = window.ZYX_VD || { products: {}, variants: {} };
  const infoEl = document.querySelector('[data-zyx-vi]');
  const prodEl = document.querySelector('script[data-zyx-product]');
  let product = null;
  try { product = prodEl ? JSON.parse(prodEl.textContent) : null; } catch (e) { product = null; }
  const pmeta = product ? (VD.products[product.handle] || {}) : {};

  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const money = cents => (Math.round(cents) / 100).toFixed(2).replace('.', ',') + ' €';
  const info = name => VD.variants[(name || '').trim()] || null;
  // Farbe: aus den Zydonia-Daten, sonst die in Shopify hinterlegte Farbe der Option, sonst neutral
  const colorFor = (name, fallback) => (info(name) || {}).c || fallback || '#cfc6b8';
  const dot = c => `<i class="zyx-dot" style="--c:${esc(c)}" aria-hidden="true"></i>`;

  /* ---------- Info-Block ---------- */
  function renderInfo(v) {
    // Eigene Galerie auch auf Seiten ohne Info-Block (z. B. Refill)
    if (v && !infoEl) { renderCandleGallery(v.title); return; }
    if (!infoEl || !v) return;
    const d = info(v.title) || {};
    const q = s => infoEl.querySelector(s);
    if (pmeta.over) q('[data-zyx-vi-over]').textContent = pmeta.over;
    q('[data-zyx-vi-name]').textContent = v.title && !/default/i.test(v.title) ? v.title : product.title;
    const sub = q('[data-zyx-vi-sub]'); sub.textContent = d.sub || ''; sub.hidden = !d.sub;
    q('[data-zyx-vi-price]').textContent = money(v.price);
    const was = q('[data-zyx-vi-was]'); was.hidden = !(v.compare > v.price); if (v.compare > v.price) was.textContent = money(v.compare);
    const unit = q('[data-zyx-vi-unit]');
    unit.textContent = pmeta.unit ? `Grundpreis ${money(v.price / pmeta.unit * 100)} / 100 ml, inkl. MwSt.` : '';
    const line = q('[data-zyx-vi-line]'); line.textContent = d.line || ''; line.hidden = !d.line;
    const notes = (d.notes || []).slice(0, 3);
    q('[data-zyx-vi-notes]').innerHTML = notes.length ? `<span class="zyx-vi__notes-label">${d.family ? esc(d.family) + ' · ' : ''}Hauptnoten</span>${notes.map(n => `<span class="zyx-chip">${esc(n)}</span>`).join('')}` : '';
    infoEl.style.setProperty('--zyx-accent', colorFor(v.title));
    infoEl.dataset.variant = v.id;
    infoEl.classList.remove('is-swap'); void infoEl.offsetWidth; infoEl.classList.add('is-swap');
    renderEffect(v.title);
    renderOilPower(v.title);
    renderCandleGallery(v.title);
  }

  /* ---------- Kerzen und Parfums: eigene Galerie mit 4 Bildern je Duft, helle und dunkle Version
     (Theme-Dateien zy-[day-]<präfix>-<duft>-<n>-<breite>.webp, Duft als Kleinschreibung ohne Apostroph, z. B. elixir-dor) ---------- */
  const slug = t => t.toLowerCase().replace(/['’]/g, '').replace(/\s+/g, '-');
  const GALLERIES = {
    'raumduft-150-ml': { prefix: 'rd8', label: 'Raumduft 150 ml', names: ['Light Jasmin', 'Rose Garden', 'Bergamot Breeze', 'Sunshine Vibes', 'Royal Saffron', 'Ginger Flower', 'Lavender Dream', 'Lipa Spa', 'Mystic Ouds'].map(slug) },
    'premium-duftkerzen-530ml': { prefix: 'kz3', label: 'Duftkerze', names: ['Lavenna', 'Lorena', 'Lule', 'Lume'] },
    'extrait-de-parfum-collection': { prefix: 'pf8', label: 'Extrait de Parfum', names: ['Rosalia', 'Nocturne', 'Invisible Desire', 'Eternelle', 'Essence Absolue', 'elixir-dor', 'Eden', 'Aqua Celeste', 'Soleira', 'Persian Nights'].map(slug) },
    // Bilder für Sunshine Vibes, Rose Garden, Bergamot Breeze und Royal Saffron liegen schon bereit (rf8-…), hier ergänzen, sobald die Sorten verfügbar sind
    'raumduft-refill-500-ml': { prefix: 'rf8', label: 'Refill 500 ml', names: ['Light Jasmin', 'Ginger Flower', 'Lipa Spa', 'Lavender Dream', 'Mystic Ouds'].map(slug) },
    '100-naturliche-bio-ole': { prefix: 'oel8', label: 'Ätherisches Öl', names: ['Lavendel', 'Weihrauch', 'Rosmarin', 'Vanille', 'Patchouli', 'Bergamotte', 'Zitronengras', 'Grapefruit', 'Jasmin', 'Ylang Ylang', 'Rose', 'Niaouli', 'Zedernholz', 'Eukalytpus', 'Orange'].map(slug) }
  };
  let kzTitle = null, kzObserver = null;
  function renderCandleGallery(title, keep) {
    const cfg = product && GALLERIES[product.handle];
    if (!cfg || !title) return;
    if (!cfg.names.map(slug).includes(slug(title))) {
      // Variante ohne eigene Bilder: eigene Galerie weg, Galerie des Themes bzw. der App wieder zeigen
      kzTitle = null;
      document.documentElement.classList.remove('zyx-own-gal');
      const old = document.querySelector('.zyx-kg');
      if (old) { old.parentElement.classList.remove('zyx-kg-on'); old.remove(); }
      return;
    }
    // Die Swatch-App (Variant Image Wizard) blendet Crafts Bildbereich aus und baut einen eigenen mit .rio-media-gallery
    const wrap = document.querySelector('.product__media-wrapper:has(.rio-media-gallery)') ||
      Array.from(document.querySelectorAll('.product__media-wrapper')).find(w => w.style.display !== 'none');
    if (!wrap) return;
    kzTitle = title;
    if (!kzObserver) {
      // Die App baut ihren Bereich erst später oder neu: Galerie dann in den sichtbaren Bereich umsetzen
      kzObserver = new MutationObserver(() => {
        const rio = document.querySelector('.product__media-wrapper:has(.rio-media-gallery)');
        if (kzTitle && rio && !rio.querySelector('.zyx-kg')) renderCandleGallery(kzTitle);
      });
      kzObserver.observe(wrap.closest('.product') || document.body, { childList: true, subtree: true });
    }
    let g = document.querySelector('.zyx-kg');
    if (g && g.parentElement !== wrap) { wrap.prepend(g); wrap.classList.add('zyx-kg-on'); }
    if (!g) {
      g = document.createElement('div');
      g.className = 'zyx-kg';
      g.innerHTML = '<div class="zyx-kg__track" data-kg-track></div><div class="zyx-kg__thumbs" data-kg-thumbs role="tablist" aria-label="Bilder"></div>';
      wrap.prepend(g);
      wrap.classList.add('zyx-kg-on');
      const track = g.querySelector('[data-kg-track]');
      g.querySelector('[data-kg-thumbs]').addEventListener('click', e => {
        const b = e.target.closest('button');
        if (!b) return;
        track.scrollTo({ left: track.clientWidth * Number(b.dataset.i), behavior: 'smooth' });
      });
      track.addEventListener('scroll', () => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        g.querySelectorAll('[data-kg-thumbs] button').forEach((b, k) => b.setAttribute('aria-selected', String(k === i)));
      }, { passive: true });
    }
    const light = document.documentElement.dataset.zyTheme !== 'dark';
    const base = ((window.ZY_CFG || {}).assets || '') + 'zy-' + (light ? 'day-' : '') + cfg.prefix + '-' + slug(title) + '-';
    const src = (n, w) => `${base}${n}-${w}.webp`;
    const alt = `${cfg.label} ${title}`;
    const track = g.querySelector('[data-kg-track]');
    // Beim Wechsel Tag/Nacht auf demselben Bild bleiben (keep), beim Duftwechsel wieder bei Bild 1 anfangen
    const idx = keep && track.clientWidth ? Math.min(3, Math.max(0, Math.round(track.scrollLeft / track.clientWidth))) : 0;
    track.innerHTML = [1, 2, 3, 4].map(n => `<figure class="zyx-kg__slide"><img src="${src(n, 1200)}" srcset="${src(n, 600)} 600w, ${src(n, 1200)} 1200w" sizes="(min-width: 990px) 50vw, 100vw" alt="${alt}, Bild ${n}"${n - 1 !== idx ? ' loading="lazy"' : ''}></figure>`).join('');
    g.querySelector('[data-kg-thumbs]').innerHTML = [1, 2, 3, 4].map(n => `<button type="button" role="tab" data-i="${n - 1}" aria-selected="${n - 1 === idx}" aria-label="Bild ${n}"><img src="${src(n, 600)}" alt="" loading="lazy"></button>`).join('');
    const sb = track.style.scrollBehavior; track.style.scrollBehavior = 'auto';
    track.scrollLeft = idx * track.clientWidth;
    track.style.scrollBehavior = sb;
  }
  window.addEventListener('zy:theme', () => { if (kzTitle) renderCandleGallery(kzTitle, true); });

  /* ---------- „Die Kraft von Ätherischen Ölen“ (Öl-Seite): Bild und Zeile zum gewählten Öl ---------- */
  let oilPowerTitle = null;
  function renderOilPower(title) {
    const el = document.querySelector('[data-zyx-oilpower]');
    if (!el) return;
    oilPowerTitle = title;
    // Bild 2 des Öls (Flasche mit Zutaten), helle oder dunkle Version
    const src = VD.oilImg && VD.oilImg(title, 2, 1200);
    const img = el.querySelector('[data-oilpower-img]');
    if (src && img) { img.src = src; img.alt = title + ', ätherisches Öl von Zydonia'; }
    const d = info(title);
    const box = el.querySelector('[data-oilpower-chosen]');
    if (!d || !box) return;
    box.hidden = false;
    el.querySelector('[data-oilpower-dot]').style.background = d.c || '#cfc6b8';
    el.querySelector('[data-oilpower-name]').textContent = `${title}: ${d.sub}`;
    el.querySelector('[data-oilpower-line]').textContent = d.line;
  }
  window.addEventListener('zy:theme', () => { if (oilPowerTitle) renderOilPower(oilPowerTitle); });

  /* ---------- „Wirkung des gewählten Dufts“ (Raumduft-Seite) ---------- */
  const MOMENT = { morgen: 'Morgens', tag: 'Tagsüber', abend: 'Abends' };
  // Bildausschnitt der Zutaten-Aufnahme je Duft (Hauptaroma in die Mitte), wie im Redesign
  // Raumdüfte mit eigenem Flatlay für „Wirkung des gewählten Dufts“ (Düfte ohne Eintrag zeigen das Zutatenbild)
  const RD_FLATLAY = ['rose-garden', 'light-jasmin', 'lavender-dream', 'lipa-spa', 'mystic-ouds', 'royal-saffron', 'sunshine-vibes', 'bergamot-breeze', 'ginger-flower'];
  const ING = { 'royal-saffron': 0, 'lavender-dream': 9, 'light-jasmin': 28, 'bergamot-breeze': 43, 'sunshine-vibes': 43, 'lipa-spa': 56, 'ginger-flower': 70, 'rose-garden': 83, 'mystic-ouds': 100 };
  function renderEffect(title) {
    const el = document.querySelector('[data-zyx-effect]');
    const Z = window.ZY;
    if (!el || !Z) return;
    const s = Z.scents.find(x => x.name === title);
    const d = info(title);
    if (d && d.pf) return renderPerfumeEffect(el, title, d);
    if (!s || !d) return;
    const q = sel => el.querySelector(sel);
    // Test: Flatlay je Raumduft (zy-rdflat-<duft>-1200.webp, eine Version für Tag und Nacht); Düfte ohne Flatlay behalten das Zutatenbild
    const img = q('[data-effect-img]');
    if (RD_FLATLAY.includes(s.id)) {
      img.removeAttribute('srcset');
      img.src = Z.asset(`rdflat-${s.id}-1200.webp`, false);
      img.style.objectPosition = '50% 50%';
    } else {
      img.setAttribute('srcset', `${Z.img('ingredients', 1200)} 1200w, ${Z.img('ingredients', 2400)} 2400w`);
      img.src = Z.img('ingredients', 2400);
      img.style.objectPosition = `${ING[s.id] == null ? 50 : ING[s.id]}% 50%`;
    }
    const m = q('[data-effect-moment]'); m.textContent = MOMENT[s.moment] || ''; m.style.setProperty('--scent-c', s.glow);
    q('[data-effect-title]').textContent = (d.sub || s.mood) + '.';
    q('[data-effect-line]').textContent = d.line || s.line;
    const pyr = d.pyr || { top: d.notes || [], heart: [], base: [] };
    q('[data-effect-pyr]').innerHTML = [['Kopfnote', pyr.top], ['Herznote', pyr.heart], ['Basisnote', pyr.base]]
      .filter(([, list]) => list && list.length)
      .map(([k, list]) => `<li><span>${k}</span><strong>${esc(list.join(', '))}</strong></li>`).join('');
    const a = q('[data-effect-link]');
    if (!a.dataset.tpl) a.dataset.tpl = a.textContent;
    a.textContent = a.dataset.tpl.replace('[Duft]', title);
    a.dataset.scent = title;
  }
  // Parfum-Landingpage: Wirkungsworte, Leitsatz, Kurzbeschreibung, Duftpyramide, Wirkung, Bild mit Zutaten (Galeriebild 2), Link zur Parfum-Seite
  function renderPerfumeEffect(el, title, d) {
    const q = sel => el.querySelector(sel);
    el.classList.add('is-pf');
    const img = q('[data-effect-img]');
    // Test: Flatlay mit allen Zutaten (zy-pfflat-<duft>-1200.webp, eine Version für Tag und Nacht).
    // Zurück auf das Galeriebild 2 (Flasche mit Zutaten, Tag/Nacht), indem PF_FLATLAY auf false gesetzt wird.
    const PF_FLATLAY = true;
    img.removeAttribute('srcset');
    img.src = PF_FLATLAY ? window.ZY.asset(`pfflat-${slug(title)}-1200.webp`, false)
      : window.ZY.asset(`pf8-${slug(title)}-2-1200.webp`, window.ZY.isLight());
    img.alt = `${title} Extrait de Parfum mit seinen Duftnoten`;
    img.style.objectPosition = '50% 50%';
    const m = q('[data-effect-moment]'); m.textContent = d.pf.words; m.style.setProperty('--scent-c', d.c || '#c3a15a');
    q('[data-effect-title]').textContent = d.sub || title;
    q('[data-effect-line]').textContent = d.pf.about;
    const pyr = d.pyr || {};
    q('[data-effect-pyr]').innerHTML = [['Kopfnote', pyr.top], ['Herznote', pyr.heart], ['Basisnote', pyr.base]]
      .filter(([, list]) => list && list.length)
      .map(([k, list]) => `<li><span>${k}</span><strong>${esc(list.join(', '))}</strong></li>`).join('');
    const more = q('[data-effect-more]');
    if (more) { more.textContent = d.pf.effect; more.hidden = !d.pf.effect; }
    const a = q('[data-effect-link]');
    if (!a.dataset.tpl) a.dataset.tpl = a.textContent;
    a.textContent = a.dataset.tpl.replace('[Duft]', title);
    a.href = d.pf.url;
    a.dataset.pf = '1';
  }
  window.addEventListener('zy:theme', () => {
    const el = document.querySelector('[data-zyx-effect]');
    const t = el && infoEl && product && (variantById(infoEl.dataset.variant) || {}).title;
    if (t && (info(t) || {}).pf) renderEffect(t);
  });

  // Link: zum Abschnitt „So wirken unsere Düfte …“ scrollen und den Eintrag des Dufts öffnen
  document.addEventListener('click', e => {
    const a = e.target.closest && e.target.closest('[data-effect-link]');
    if (!a || a.dataset.pf) return;
    const heads = Array.from(document.querySelectorAll('#MainContent .collapsible-content h2, #MainContent .collapsible-content .title'));
    const head = heads.find(h => /So wirken unsere Düfte/i.test(h.textContent));
    const sec = head && head.closest('.shopify-section');
    if (!sec) return;
    e.preventDefault();
    const row = Array.from(sec.querySelectorAll('details')).find(dt => (dt.querySelector('summary') || dt).textContent.includes(a.dataset.scent || ''));
    const target = row || sec;
    if (row) { sec.querySelectorAll('details[open]').forEach(dt => { if (dt !== row) dt.removeAttribute('open'); }); row.setAttribute('open', ''); }
    target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });
  const variantById = id => product && product.variants.find(x => String(x.id) === String(id));
  // Kurzer Link je Duft: ?duft=invisible-desire oder ?duft=6 (Nummer = Reihenfolge der Varianten in Shopify); sonst ?variant=<ID>
  const urlVariant = () => {
    const q = new URLSearchParams(location.search), d = (q.get('duft') || '').trim().toLowerCase();
    if (d && product) {
      const n = /^\d{1,2}$/.test(d) ? product.variants[+d - 1] : product.variants.find(x => slug(x.title) === d);
      if (n) return n;
    }
    return variantById(q.get('variant'));
  };
  // Adresszeile beim Duftwechsel mitführen, damit der Link direkt geteilt werden kann
  const setUrlVariant = v => {
    if (!v || !history.replaceState) return;
    const q = new URLSearchParams(location.search);
    q.delete('variant'); q.set('duft', slug(v.title));
    history.replaceState(history.state, '', location.pathname + '?' + q.toString() + location.hash);
  };
  const variantByTitle = t => product && product.variants.find(x => x.title === t);
  function showVariantId(id) { const v = variantById(id); if (v && String(infoEl && infoEl.dataset.variant) !== String(id)) renderInfo(v); else if (v && infoEl && !infoEl.dataset.rendered) { renderInfo(v); infoEl.dataset.rendered = '1'; } }

  /* ---------- Aufklappfeld mit Farbpunkten für Auswahllisten ---------- */
  function optLabel(o) { return (o.getAttribute('data-zyd-title') || o.textContent || '').replace(/\s*\(.*?\)\s*$/, '').trim(); }
  function enhanceSelect(sel) {
    if (sel.dataset.zyxDone) return;
    sel.dataset.zyxDone = '1';
    const wrap = document.createElement('div');
    wrap.className = 'zyx-dd';
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(sel);
    sel.classList.add('zyx-native');
    sel.tabIndex = -1;
    sel.setAttribute('aria-hidden', 'true');
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'zyx-dd__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    wrap.appendChild(btn);
    const list = document.createElement('div');
    list.className = 'zyx-dd__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    wrap.appendChild(list);
    const sync = () => {
      const o = sel.options[sel.selectedIndex];
      const name = o ? optLabel(o) : '';
      btn.innerHTML = `${dot(colorFor(name))}<span class="zyx-dd__name">${esc(name)}</span><i class="zyx-caret" aria-hidden="true"></i>`;
      btn.setAttribute('aria-label', `${name}, ändern`);
    };
    const build = () => {
      list.innerHTML = Array.from(sel.options).map((o, i) => {
        const name = optLabel(o);
        const extra = o.disabled ? '<small>ausverkauft</small>' : '';
        return `<button type="button" role="option" class="zyx-dd__opt" data-i="${i}" aria-selected="${i === sel.selectedIndex}"${o.disabled ? ' disabled' : ''}>${dot(colorFor(name))}<span>${esc(name)}</span>${extra}</button>`;
      }).join('');
    };
    const close = () => { list.hidden = true; btn.setAttribute('aria-expanded', 'false'); wrap.classList.remove('is-open'); };
    btn.addEventListener('click', () => {
      if (!list.hidden) { close(); return; }
      document.querySelectorAll('.zyx-dd.is-open').forEach(x => x !== wrap && x.querySelector('.zyx-dd__btn').click());
      build();
      list.hidden = false;
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      const cur = list.querySelector('[aria-selected="true"]') || list.querySelector('button:not([disabled])');
      if (cur) cur.focus({ preventScroll: true });
    });
    list.addEventListener('click', e => {
      const o = e.target.closest('.zyx-dd__opt');
      if (!o || o.disabled) return;
      sel.selectedIndex = parseInt(o.dataset.i, 10);
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      sync();
      close();
      btn.focus({ preventScroll: true });
    });
    list.addEventListener('keydown', e => {
      const all = Array.from(list.querySelectorAll('button:not([disabled])'));
      const i = all.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (all[i + 1] || all[0]).focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); (all[i - 1] || all[all.length - 1]).focus(); }
      if (e.key === 'Escape') { close(); btn.focus(); }
    });
    wrap._zyxClose = close;
    sel.addEventListener('change', sync);
    sync();
    // Die Buybox setzt beim Start Werte ohne change-Ereignis: kurz nachziehen
    setTimeout(sync, 300); setTimeout(sync, 1200);
    sel._zyxSync = sync;
  }

  // Ein gemeinsamer Beobachter schließt offene Aufklappfelder beim Klick daneben
  document.addEventListener('click', e => {
    document.querySelectorAll('.zyx-dd.is-open').forEach(w => { if (!w.contains(e.target) && w._zyxClose) w._zyxClose(); });
  });
  // Auch für den Warenkorb (zyx-cart.js) nutzbar
  window.ZYXDots = { enhance: enhanceSelect };

  /* ---------- Knöpfe mit Farbpunkt für die Craft-Variantenauswahl ---------- */
  function enhanceCraft(fs) {
    if (fs.dataset.zyxDone) return;
    const inputs = Array.from(fs.querySelectorAll('input[type="radio"]'));
    if (!inputs.length) {
      const s = fs.querySelector('select');
      if (s) enhanceSelect(s);
      fs.dataset.zyxDone = '1';
      return;
    }
    fs.dataset.zyxDone = '1';
    fs.classList.add('zyx-craft-hidden');
    const grid = document.createElement('div');
    grid.className = 'zyx-opts';
    grid.setAttribute('role', 'radiogroup');
    const legend = fs.querySelector('legend');
    grid.setAttribute('aria-label', legend ? legend.textContent.split(':')[0].trim() : 'Variante wählen');
    grid.innerHTML = inputs.map((inp, i) => {
      const lab = fs.querySelector(`label[for="${inp.id}"]`);
      const sw = lab && lab.querySelector('.swatch');
      const shopColor = sw ? sw.style.getPropertyValue('--swatch--background') : '';
      const pv = inputs.length > 0 && product && product.variants.length === inputs.length ? variantByTitle(inp.value) : null;
      const soldOut = inp.classList.contains('disabled') || inp.hasAttribute('disabled') || (pv ? !pv.available : false);
      return `<button type="button" role="radio" class="zyx-opt${soldOut ? ' is-soldout' : ''}" aria-checked="${inp.checked}" data-for="${esc(inp.id)}">
        ${dot(colorFor(inp.value, shopColor))}<span class="zyx-opt__name">${esc(inp.value)}${soldOut ? '<small>ausverkauft</small>' : ''}</span></button>`;
    }).join('');
    // Außerhalb von <variant-selects> einsetzen: Die Swatch-App blendet dieses Element aus, und Craft ersetzt seinen Inhalt beim Wechsel
    const picker = fs.closest('variant-selects, variant-radios') || fs;
    const key = (picker.id || 'picker') + ':' + Array.from(picker.querySelectorAll('fieldset')).indexOf(fs);
    grid.dataset.key = key;
    document.querySelectorAll('.zyx-opts').forEach(g => { if (g.dataset.key === key) g.remove(); });
    picker.parentNode.insertBefore(grid, picker);
    grid.addEventListener('click', e => {
      const b = e.target.closest('.zyx-opt');
      if (!b) return;
      const inp = document.getElementById(b.dataset.for);
      if (!inp) return;
      grid.querySelectorAll('.zyx-opt').forEach(x => x.setAttribute('aria-checked', String(x === b)));
      inp.click();
      // Raumduft: der erste Duft der Buybox folgt der Auswahl
      const v = variantByTitle(inp.value);
      const first = document.querySelector('select[data-zyd-scent]');
      if (v && first && Array.from(first.options).some(o => o.value === String(v.id) && !o.disabled)) {
        first.value = String(v.id);
        first.dispatchEvent(new Event('change', { bubbles: true }));
        if (first._zyxSync) first._zyxSync();
      }
      if (v) renderInfo(v);
    });
  }

  /* ---------- „Deine Geschenke“: Geschenkfelder der Buybox abgesetzt und mit Bild ---------- */
  function giftImage(sel) {
    const Z = window.ZY;
    if (!Z) return '';
    const o = sel.options[sel.selectedIndex];
    const name = o ? optLabel(o) : '';
    if (sel.getAttribute('data-zyd-gift') === 'room') {
      const s = Z.scents.find(x => x.name === name);
      return s ? Z.img('pack-' + s.id, 240) : Z.img('pack-lavender-dream', 240);
    }
    // Öl: Produktfoto der gewählten Sorte, sonst das Redesign-Bild
    return (VD.oilImages || {})[name] || Z.img('pack-oil', 300);
  }
  function enhanceGifts() {
    const fields = Array.from(document.querySelectorAll('.zyd-bb__field--gift'));
    if (!fields.length || fields[0].closest('.zyx-gifts')) return;
    const box = document.createElement('div');
    box.className = 'zyx-gifts';
    box.innerHTML = '<div class="zyx-gifts__head"><p class="zyx-gifts__title">Deine Geschenke</p><span class="zyx-gifts__sub">Gratis dazu</span></div>';
    // Als eigener Kasten direkt unter „Wähle deine Düfte“ (gleiche Breite und gleicher Rahmen)
    const scents = fields[0].closest('.zyd-bb__scents');
    if (scents) scents.parentNode.insertBefore(box, scents.nextSibling);
    else fields[0].parentNode.insertBefore(box, fields[0]);
    fields.forEach(f => {
      box.appendChild(f);
      const sel = f.querySelector('select');
      const wrap = document.createElement('span');
      wrap.className = 'zyx-gift-img';
      wrap.innerHTML = '<img alt="" loading="lazy">';
      f.insertBefore(wrap, f.firstChild);
      const upd = () => { const src = sel ? giftImage(sel) : ''; if (src) wrap.firstChild.src = src; };
      if (sel) sel.addEventListener('change', upd);
      upd(); setTimeout(upd, 400);
    });
    // Kasten nur zeigen, wenn die Buybox mindestens ein Geschenkfeld einblendet
    const vis = () => { box.hidden = !fields.some(f => f.style.display !== 'none' && !f.hidden); };
    fields.forEach(f => new MutationObserver(vis).observe(f, { attributes: true, attributeFilter: ['style', 'hidden'] }));
    vis();
  }

  /* ---------- „Dazu passt“: Refill zum gewählten Raumduft (nur Raumduft-Buybox) ---------- */
  function renderAddons() {
    const box = document.querySelector('[data-zyx-addons]');
    const Z = window.ZY;
    const refill = ((window.ZY_CFG || {}).products || {}).refill;
    if (!box || !Z || !refill) return;
    // Gewählte Düfte in der Reihenfolge der sichtbaren Felder
    const chosen = Array.from(document.querySelectorAll('[data-zyd-scent-wrap]'))
      .filter(w => w.style.display !== 'none' && !w.hidden)
      .map(w => { const s = w.querySelector('select'); const o = s && s.options[s.selectedIndex]; return o ? optLabel(o) : ''; });
    const name = chosen.find(n => refill.variants[n] && refill.variants[n].available);
    if (!name) { box.hidden = true; box.innerHTML = ''; return; }
    const v = refill.variants[name];
    const prev = box.querySelector('[data-zyx-refill]');
    const checked = prev ? prev.checked : false;
    if (prev && prev.value === String(v.id)) { box.hidden = false; return; }
    box.innerHTML = `
      <p class="zyx-addons__title">Dazu passt</p>
      <label class="zyx-addon${checked ? ' is-on' : ''}">
        <input type="checkbox" data-zyx-refill value="${v.id}"${checked ? ' checked' : ''}>
        <span class="zyx-addon__box" aria-hidden="true"></span>
        <span class="zyx-addon__img"><img src="${v.img || Z.img('pack-refill', 300)}" alt="Refill ${esc(name)}" loading="lazy"></span>
        <span class="zyx-addon__text">Refill 500 ml, ${esc(name)}<small>Reicht für drei Füllungen</small></span>
        <span class="zyx-addon__price">${money(v.price * 100)}</span>
      </label>`;
    box.hidden = false;
  }
  document.addEventListener('change', e => {
    if (e.target.matches && e.target.matches('[data-zyx-refill]')) e.target.closest('.zyx-addon').classList.toggle('is-on', e.target.checked);
    if (e.target.matches && e.target.matches('select[data-zyd-scent], input[name="zyd-bb-opt"]')) setTimeout(renderAddons, 30);
  });
  document.querySelectorAll('[data-zyd-scent-wrap]').forEach(w => new MutationObserver(() => renderAddons()).observe(w, { attributes: true, attributeFilter: ['style', 'hidden'] }));

  function enhanceAll() {
    enhanceGifts();
    renderAddons();
    document.querySelectorAll('variant-selects fieldset, variant-radios fieldset, variant-selects .product-form__input--dropdown').forEach(enhanceCraft);
    document.querySelectorAll('select[data-zyd-scent], select[data-zyd-gift]').forEach(enhanceSelect);
  }

  /* ---------- Quellen für die gewählte Variante ---------- */
  // Craft meldet Variantenwechsel über pubsub
  // PUB_SUB_EVENTS ist in Craft eine globale Konstante (constants.js), nicht window.PUB_SUB_EVENTS
  const EVENTS = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null; // eslint-disable-line no-undef
  if (typeof window.subscribe === 'function' && EVENTS && EVENTS.variantChange) {
    window.subscribe(EVENTS.variantChange, e => {
      const v = e && e.data && e.data.variant;
      if (v) renderInfo({ id: v.id, title: v.title, price: v.price, compare: v.compare_at_price || 0 });
    });
  }
  // Parfum-Buybox: die Duft-Knöpfe („Dein Duft“) bestimmen, was oben steht
  document.addEventListener('click', e => {
    const sw = e.target.closest && e.target.closest('[data-zyd-swatch]');
    if (sw && sw.getAttribute('data-zyd-oos') !== '1') showVariantId(sw.getAttribute('data-zyd-swatch'));
  });
  // Buyboxen: der erste Duft bestimmt, was oben steht
  document.addEventListener('change', e => {
    const s = e.target;
    if (s.matches && s.matches('select[data-zyd-scent]') && s === document.querySelector('select[data-zyd-scent]')) { showVariantId(s.value); setUrlVariant(variantById(s.value)); }
  });

  // Craft ersetzt beim Variantenwechsel Teile der Seite: neu entstandene Felder wieder anpassen
  const mo = new MutationObserver(() => { clearTimeout(mo.t); mo.t = setTimeout(enhanceAll, 60); });
  const scope = document.querySelector('.product__info-container, product-info, main') || document.body;
  mo.observe(scope, { childList: true, subtree: true });

  enhanceAll();

  /* ---------- Start: Info zur aktuellen Variante ---------- */
  if (infoEl && product) {
    const first = document.querySelector('select[data-zyd-scent]');
    let v = urlVariant();
    if (v && first && Array.from(first.options).some(o => o.value === String(v.id) && !o.disabled)) {
      setTimeout(() => { first.value = String(v.id); first.dispatchEvent(new Event('change', { bubbles: true })); if (first._zyxSync) first._zyxSync(); }, 400);
    }
    if (!v && first) v = variantById(first.value);
    if (!v) { const idInput = document.querySelector('form[action*="/cart/add"] [name="id"]'); v = variantById(idInput && idInput.value) || variantById(infoEl.dataset.variant) || product.variants[0]; }
    renderInfo(v);
  }

  /* ---------- Seiten ohne Info-Block, aber mit eigener Galerie (Refill): Produktdaten nachladen ---------- */
  const handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
  if (!product && handle && GALLERIES[handle]) {
    fetch(`${((window.ZY_CFG || {}).routes || {}).root || '/'}products/${handle}.js`.replace('//products', '/products'))
      .then(r => r.json())
      .then(p => {
        product = p;
        const idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
        const v = urlVariant() || variantById(idInput && idInput.value) || p.variants.find(x => x.available) || p.variants[0];
        if (v) renderCandleGallery(v.title);
      }).catch(() => {});
  }
})();
